var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"biNav"},[_c('p',{staticClass:"page_title"},[_vm._v("三门峡市应急救援装备管理服务平台")])])
}]

export { render, staticRenderFns }